module.exports = __webpack_public_path__ + "media/images/emblems/Gilly-coat_of_arms-c25311124772ccdefae9ca571a3e0928.svg";